import { useState } from 'react'
import { useMediaSrc } from '../../library/useMediaSrc'
import { useMe } from '../useMe'

const initialOf = (name: string) => name.replace(/[^\p{L}\p{N}]/gu, '').slice(0, 1).toUpperCase()

/**
 * The creator's own Fansly picture, from account/me (the pages' shared copy).
 * The accounts row keeps a Fansly CDN link from the first connect, and Fansly
 * signs those for about a week, so it is only the fallback while /me loads.
 * Needs the account's Fansly deps (AccountFanslyDeps).
 */
export function MePic({ name, fallbackUrl, className }: { name: string; fallbackUrl?: string | null; className: string }) {
  const me = useMe()
  const live = useMediaSrc(me?.avatar ?? '')
  const [brokenFallback, setBrokenFallback] = useState(false)
  const fallback = !me && fallbackUrl && /^https?:/i.test(fallbackUrl) && !brokenFallback ? fallbackUrl : null
  const src = live.src ?? fallback
  return (
    <span ref={live.ref as React.RefObject<HTMLSpanElement>} className={className}>
      {src ? <img src={src} alt="" onError={() => src === fallback && setBrokenFallback(true)} /> : initialOf(me?.name || name)}
    </span>
  )
}
